$.html5camera = {
	
	controls: null,
	cameraOptions: null,
	video: null,
	canvas: null,
	screenshotImage: null,
	streamStarted: false,
	play: null,
	pause: null,
	screenshot: null,
	close: null,
	constraints: {},
	
	init: function(target){
		
		feather.replace();
		
		this.controls = target.querySelector('.controls');
		this.cameraOptions = target.querySelector('.video-options>select');
		this.video = target.querySelector('video');
		this.canvas = target.querySelector('canvas');
		this.screenshotImage = target.querySelector('img#screenshot-image');
		
		if(this.controls) {
			
			this.streamStarted = false;
			
			[this.play, this.pause, this.screenshot, this.close] = [...this.controls.querySelectorAll('button')];
			
			this.constraints = {
				video: {
					width: {
						min: 1280,
						ideal: 1920,
						max: 2560,
					},
					height: {
						min: 720,
						ideal: 1080,
						max: 1440
					},
					facingMode: "environment",
				}
			};
			
			this.cameraOptions.onchange = () => {
				
				if(this.video.srcObject) {
					this.video.srcObject.getTracks().forEach(track => track.stop())
				}
				
				const constraints = {video: {}}
				constraints['video']['width'] = this.constraints.video.width;
				constraints['video']['height'] = this.constraints.video.height;
				constraints['video']['deviceId'] = {exact: this.cameraOptions.value};
				
				this.startStream(constraints).then(stream => {
					this.handleStream(stream);
				});
			};
			
			this.play.onclick = () => {this.firstStart()}
			this.pause.onclick = () => {this.pauseStream};
			this.screenshot.onclick = () => {this.doScreenshot};
			this.close.onclick = () => {
				this.pauseStream
				$('dialog.camera-dialog').get(0).close()
				$('dialog.camera-dialog').remove()
			};
			
			this.getCameraSelection().then(options => {
				this.cameraOptions.innerHTML = options
			});
			
			this.firstStart();
		}
	},
	
	firstStart: function(){
		if (this.streamStarted) {
			this.video.play();
			this.play.classList.add('d-none');
			this.pause.classList.remove('d-none');
			return;
		}
		if ('mediaDevices' in navigator && navigator.mediaDevices.getUserMedia) {
			this.startStream(this.constraints).then(stream => {
				this.handleStream(stream);
			});
		}
	},
	
	pauseStream: function(){
		this.video.pause();
		this.play.classList.remove('d-none');
		this.pause.classList.add('d-none');
		
		if(this.video.srcObject) {
			this.video.srcObject.getTracks().forEach(track => track.stop())
		}
	},
	
	doScreenshot: function(){
		this.canvas.width = this.video.videoWidth;
		this.canvas.height = this.video.videoHeight;
		this.canvas.getContext('2d').drawImage(this.video, 0, 0);
		this.screenshotImage.src = this.canvas.toDataURL('image/webp');
		this.screenshotImage.classList.remove('d-none');
	},
	
	startStream: async function(constraints){
		return await navigator.mediaDevices.getUserMedia(constraints);
		
	},
	
	handleStream: function(stream){
		this.video.srcObject = stream;
		this.play.classList.add('d-none');
		this.pause.classList.remove('d-none');
		this.screenshot.classList.remove('d-none');
	},
	
	getCameraSelection: async function(){
		const devices = await navigator.mediaDevices.enumerateDevices();
		const videoDevices = devices.filter(device => device.kind === 'videoinput');
		const options = videoDevices.map(videoDevice => {
			return `<option value="${videoDevice.deviceId}">${videoDevice.label}</option>`;
		});
		return options.join('');
	},
	
	toFile: function(filename) {
		
		this.canvas.width = this.video.videoWidth;
		this.canvas.height = this.video.videoHeight;
		this.canvas.getContext('2d').drawImage(this.video, 0, 0);
		
		let dataurl = this.canvas.toDataURL('image/webp')
		
		var arr = dataurl.split(','),
		  mime = arr[0].match(/:(.*?);/)[1],
		  bstr = atob(arr[arr.length - 1]),
		  n = bstr.length,
		  u8arr = new Uint8Array(n);
		while(n--){
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename + '.webp', {type:mime});
	},
	
}